/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import agLegend from './ag-legend.directive';
import agFlot from './flot.directive';
import agTemperaturesTable from './temperatures-table.directive';
import agTemperatures from './temperatures.directive';
import agDisableSensorsTable from './disable-sensors.directive';
import agSelectSensorsTable from './select-sensors.directive';
import agDigitalGauge from './digital-gauge.directive';
import agGatewayInfo from './gateway-info.directive';

export default angular.module('agrolog.client.components', [
    agLegend,
    agFlot,
    agTemperaturesTable,
    agTemperatures,
    agDisableSensorsTable,
    agSelectSensorsTable,
    agDigitalGauge,
    agGatewayInfo
    ])
    .name;
